import React, { useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  CircularProgress,
  Alert,
  Box,
  Typography,
} from '@mui/material'
import API_URL from '../../config/api'
import './login.scss'

export default function LoginModal({ open, onClose, onLoginSuccess }) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
    setError('')
  }

  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  const handleLogin = async (e) => {
    e.preventDefault()
    if (!formData.email || !formData.password) {
      setError('Por favor completa todos los campos')
      return
    }

    if (!validateEmail(formData.email)) {
      setError('Ingresa un correo válido')
      return
    }

    setLoading(true)
    try {
      const response = await fetch(`${API_URL}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: formData.email,
          password: formData.password,
        }),
      })

      const data = await response.json()

      if (!response.ok) {
        throw new Error(data.error || 'Error al iniciar sesión')
      }

      // Save token and user info
      localStorage.setItem('token', data.token)
      localStorage.setItem('user', JSON.stringify(data.data))

      onLoginSuccess(data.data)
      setFormData({ email: '', password: '' })
      onClose()
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="sm" 
      fullWidth 
      className="login-modal"
      disableScrollLock={true}
      PaperProps={{
        sx: {
          m: { xs: 1, sm: 2 },
        }
      }}
    >
      <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', py: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
          <Box
            component="img"
            src={require('../../asset/images/Ingeniosoft-textoblanco.png').default}
            alt="Ingeniosoft Logo"
            sx={{ height: 50, width: 'auto', objectFit: 'contain', minWidth: 50 }}
          />
          <Typography sx={{ color: 'white', fontSize: '1.25rem', fontWeight: 600 }}>
            Inicio de Sesión
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent dividers>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
            {error}
          </Alert>
        )}

        <Box component="form" onSubmit={handleLogin} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField
            fullWidth
            label="Correo"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            disabled={loading}
          />

          <TextField
            fullWidth
            label="Contraseña"
            name="password"
            type="password"
            value={formData.password}
            onChange={handleChange}
            disabled={loading}
          />

          <Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            disabled={loading}
            sx={{ mt: 2 }}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Iniciar Sesión'}
          </Button>
        </Box>

        <Typography sx={{ mt: 3, fontSize: '0.875rem', color: 'text.secondary', textAlign: 'center' }}>
          ¿No tienes acceso? Contacta al administrador
        </Typography>
      </DialogContent>
    </Dialog>
  )
}

